import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

export const getStockStatusCostCenterCodes = async ({ UID, RID, StoreStatus }) => {
    try {
        const response = await axios.get(`${base}/Reports/GetstockstatusCostCenterCodes`, { params: { UID, RID, StoreStatus } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch cost centres';
    }
};

export const getStockStatusSummaryReportGrid = async ({ CCCode, Fromdate, Todate }) => {
    try {
        const response = await axios.get(`${base}/Reports/StockStatusSummaryReportGrid`, { params: { CCCode, Fromdate, Todate } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch stock status report';
    }
};

export const getStockStatusSummaryPopup = async ({ Itemcode, CCcode, FromDate, ToDate }) => {
    try {
        const response = await axios.get(`${base}/Reports/StockStatusSummaryPopup`, { params: { Itemcode, CCcode, FromDate, ToDate } });
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to fetch stock status detail';
    }
};
